module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-stone-path.9697870d.png";